function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
import { Singleton } from "../../common/models";
import { FormatLoggerPrefixPlugin, ThirdPartyIntegrationPlugin } from "./plugins";
import { NODE_PROCESS_ENVIRONMENT } from "../../common";
import { appendMetaHelpers } from "../meta/meta";

// Must use require as `import` statement may reconstruct build output
// See: https://stackoverflow.com/questions/51070138/how-to-import-package-json-into-typescript-file-without-including-it-in-the-comp
var pkg = require("../../../../package.json");
var LOG_LEVELS = {
  error: 'error',
  warn: 'warn',
  info: 'info',
  debug: 'debug',
  trace: 'trace',
  log: 'log'
};
var LOG_LEVEL_VALUES = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
  trace: 4,
  log: 5
};
var DEBUG_LOG_SETTINGS = {
  isLoud: 'att_core_is_loud',
  logLevel: 'att_core_log_level'
};

/**
 * The ScribeLogger class is a logging utility that allows for different log levels and custom plugins.
 */
var _plugins = /*#__PURE__*/new WeakMap();
var _level = /*#__PURE__*/new WeakMap();
var _write = /*#__PURE__*/new WeakSet();
export var ScribeLogger = /*#__PURE__*/function (_Singleton) {
  _inherits(ScribeLogger, _Singleton);
  var _super = _createSuper(ScribeLogger);
  function ScribeLogger() {
    var _LOG_LEVEL_VALUES$deb;
    var _this;
    _classCallCheck(this, ScribeLogger);
    _this = _super.call(this);
    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _write);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _plugins, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _level, {
      writable: true,
      value: void 0
    });
    _defineProperty(_assertThisInitialized(_this), "isMuted", void 0);
    if (ScribeLogger._instance) {
      return _possibleConstructorReturn(_this, _this.instance);
    }
    var debugLogLevel = readLogDebugSetting(DEBUG_LOG_SETTINGS.logLevel);
    var debugIsLoud = readLogDebugSetting(DEBUG_LOG_SETTINGS.isLoud);
    _classPrivateFieldSet(_assertThisInitialized(_this), _plugins, {});
    _classPrivateFieldSet(_assertThisInitialized(_this), _level, (_LOG_LEVEL_VALUES$deb = LOG_LEVEL_VALUES[debugLogLevel]) !== null && _LOG_LEVEL_VALUES$deb !== void 0 ? _LOG_LEVEL_VALUES$deb : LOG_LEVEL_VALUES.log);
    _this.isMuted = NODE_PROCESS_ENVIRONMENT === 'production';
    if (debugIsLoud !== null) {
      _this.isMuted = !debugIsLoud;
    }
    ScribeLogger._instance = _assertThisInitialized(_this);
    return _this;
  }
  _createClass(ScribeLogger, [{
    key: "error",
    value: function error(msg) {
      var _classPrivateMethodGe;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_classPrivateMethodGe = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe, [this, 'error', msg].concat(args));
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      var _classPrivateMethodGe2;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      return (_classPrivateMethodGe2 = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe2, [this, 'warn', msg].concat(args));
    }
  }, {
    key: "info",
    value: function info(msg) {
      var _classPrivateMethodGe3;
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      return (_classPrivateMethodGe3 = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe3, [this, 'info', msg].concat(args));
    }
  }, {
    key: "debug",
    value: function debug(msg) {
      var _classPrivateMethodGe4;
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      return (_classPrivateMethodGe4 = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe4, [this, 'debug', msg].concat(args));
    }
  }, {
    key: "trace",
    value: function trace(msg) {
      var _classPrivateMethodGe5;
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      return (_classPrivateMethodGe5 = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe5, [this, 'trace', msg].concat(args));
    }
  }, {
    key: "log",
    value: function log(msg) {
      var _classPrivateMethodGe6;
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      return (_classPrivateMethodGe6 = _classPrivateMethodGet(this, _write, _write2)).call.apply(_classPrivateMethodGe6, [this, 'log', msg].concat(args));
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      _classPrivateFieldGet(this, _plugins)[plugin.id] = plugin;
    }
  }, {
    key: "removePlugin",
    value: function removePlugin(pluginID) {
      if (!Object.keys(_classPrivateFieldGet(this, _plugins)).find(function (p) {
        return p === pluginID;
      })) return;
      delete _classPrivateFieldGet(this, _plugins)[pluginID];
    }
  }, {
    key: "clearPlugins",
    value: function clearPlugins() {
      _classPrivateFieldSet(this, _plugins, {});
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      _classPrivateFieldSet(this, _level, LOG_LEVEL_VALUES[level]);
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this2 = this;
      return Object.keys(_classPrivateFieldGet(this, _plugins)).reduce(function (prev, cur) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur, _classPrivateFieldGet(_this2, _plugins)[cur].constructor.name));
      }, {});
    }
  }, {
    key: "level",
    get: function get() {
      var _this3 = this;
      return Object.keys(LOG_LEVEL_VALUES).find(function (k) {
        return LOG_LEVEL_VALUES[k] === _classPrivateFieldGet(_this3, _level);
      });
    }
  }, {
    key: "instance",
    get: function get() {
      return ScribeLogger._instance;
    }
  }]);
  return ScribeLogger;
}(Singleton);
function _write2(level, msg) {
  for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
    args[_key7 - 2] = arguments[_key7];
  }
  if (!Object.hasOwn(console, level)) return null;
  Object.values(_classPrivateFieldGet(this, _plugins)).forEach(function (p) {
    var _p$processLog = p.processLog.apply(p, [level, msg].concat(_toConsumableArray(args)));
    var _p$processLog2 = _slicedToArray(_p$processLog, 3);
    level = _p$processLog2[0];
    msg = _p$processLog2[1];
    args = _p$processLog2[2];
  });
  if (this.isMuted || LOG_LEVEL_VALUES[level] > _classPrivateFieldGet(this, _level)) return args;
  if (args.length) {
    var _console;
    (_console = console)[level].apply(_console, [msg].concat(_toConsumableArray(args)));
  } else {
    console[level](msg);
  }
  return args;
}
var Scribe = new ScribeLogger();
[new FormatLoggerPrefixPlugin(), new ThirdPartyIntegrationPlugin()].forEach(function (p) {
  return Scribe.addPlugin(p);
});

// --- For debugging support ---
function writeLogDebugSetting(setting, val) {
  localStorage.setItem(setting, JSON.stringify(val));
}
function readLogDebugSetting(setting) {
  return JSON.parse(localStorage.getItem(setting));
}
function forceDebugLoud() {
  writeLogDebugSetting(DEBUG_LOG_SETTINGS.isLoud, true);
}
function forceDebugLevel(level) {
  writeLogDebugSetting(DEBUG_LOG_SETTINGS.logLevel, level);
}
function resetDebugSettings() {
  Object.values(DEBUG_LOG_SETTINGS).forEach(function (k) {
    return localStorage.removeItem(k);
  });
}
function getDebugSettings() {
  return Object.keys(DEBUG_LOG_SETTINGS).reduce(function (prev, cur) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur, readLogDebugSetting(cur)));
  }, {});
}
var scribeLoggerHelpers = _defineProperty({}, ScribeLogger.name, {
  forceDebugLoud: forceDebugLoud,
  forceDebugLevel: forceDebugLevel,
  resetDebugSettings: resetDebugSettings,
  getDebugSettings: getDebugSettings
});
appendMetaHelpers(scribeLoggerHelpers, pkg.name);
// ---

export { Scribe };